module.exports = __webpack_public_path__ + "static/media/x.e3f395a1.svg";